import { DEVELOPMENT_HOST, isProductionHost } from '../../constants/environment';
import type { OAuthClientIds } from './types';

const PRODUCTION: OAuthClientIds = {
  katana: '1NEhdd4w7Zy1OAWbYrKTSUd3h1iEsbs8',
  brightpearl: 'sparklayerb2b',
  quickbooks: 'ABg1XuLzYDUX3gFs4mLVR4RPn49wmrO4GXc0sj3vCfEL6qlZZC',
  xero: 'F3C431CE6F1548AF888DE80D505C3AF1',
};

const DEVELOPMENT: OAuthClientIds = {
  katana: '1NEhdd4w7Zy1OAWbYrKTSUd3h1iEsbs8',
  brightpearl: 'sparklayerb2bdev',
  quickbooks: 'ABCkQC3T8UvIic8wdi6vmATGVttJFUe7pLnsk9opOrmEJeiHOF',
  xero: 'BEFAF17E9B644A278FE8F2ABB9F1546B',
};

/** Local/preview hosts, whose redirect URIs are registered against separate provider apps. */
const LOCAL: OAuthClientIds = {
  katana: '1NEhdd4w7Zy1OAWbYrKTSUd3h1iEsbs8',
  brightpearl: 'sparklayerdevrhy',
  quickbooks: 'ABCkQC3T8UvIic8wdi6vmATGVttJFUe7pLnsk9opOrmEJeiHOF',
  xero: '740B07403AFB4C5F866521EED12575C9',
};

export function resolveOAuthClientIds(host: string): OAuthClientIds {
  if (isProductionHost(host)) {
    return PRODUCTION;
  }
  if (host === DEVELOPMENT_HOST) {
    return DEVELOPMENT;
  }
  return LOCAL;
}

export function getOAuthClientIds(): OAuthClientIds {
  return resolveOAuthClientIds(window.location.host);
}
